export default "__VITE_ASSET__BxJJOHbp__"